import { call, put, takeLatest } from 'redux-saga/effects'
import { t } from 'i18next'
import apiCall from '../helpers/apiCall'
import { POST } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  CREATE_MOTORBIKE_PHOTO,
  CREATE_MOTORBIKE_PHOTO_FAILURE,
  CREATE_MOTORBIKE_PHOTO_SUCCESS,
  MotorbikePhoto
} from 'src/redux/photosReducer'
import { SHOW_TOAST } from 'src/redux/toastReducer'

interface CreateMotorbikePhotoAction {
  payload: {
    motorbikeId: string
    file: string
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* CreateMotorbikePhotoFlow(action: CreateMotorbikePhotoAction): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const photo: MotorbikePhoto = yield call(apiCall, {
      endpoint: `/dealers_api/motorbikes/${action.payload.motorbikeId}/photos`,
      api: 'market-api',
      method: POST,
      params: { photo: { file: action.payload.file } }
    })
    yield put(CREATE_MOTORBIKE_PHOTO_SUCCESS(photo))
    yield put(SHOW_TOAST({ message: t('my_vehicles.photo_added') }))
  } catch (error) {
    yield put(CREATE_MOTORBIKE_PHOTO_FAILURE())
    const unsupported = error instanceof Error && error.message === 'unsupported file type'
    const message = unsupported ? t('my_vehicles.photo_type_error') : t('my_vehicles.photo_upload_error')
    yield put(SHOW_TOAST({ message }))
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* CreateMotorbikePhotoSaga(): Generator<any, void, any> {
  yield takeLatest(CREATE_MOTORBIKE_PHOTO, CreateMotorbikePhotoFlow)
}
